export default __webpack_public_path__ + "1.18.12/static/media/green-check.c88ea47e.svg";